/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { ErrorHandler, NgZone, inject } from '@angular/core';
import { OSKErrorService } from './error.service';

export class OSKGlobalErrorHandler extends ErrorHandler {
  private readonly errorService: OSKErrorService = inject(OSKErrorService);
  private readonly zone: NgZone = inject(NgZone);
  // TODO : manage errors according their cases
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // override handleError(error: any): void {
  //   this.zone.run(() => {
  //     this.errorService.showError(error.message);
  //   });
  //   if (!environment.production) {
  //     throw error;
  //   }
  // }
}
